import { render, staticRenderFns } from "./ProjectZZPerModal.vue?vue&type=template&id=eb879cdc"
import script from "./ProjectZZPerModal.vue?vue&type=script&lang=js"
export * from "./ProjectZZPerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports